import React, { useState } from 'react';
import BackButton from '../BackButton/BackButton';
import EmailForm from './EmailForm/EmailForm';
import NewPasswordForm from './NewPassword/NewPassword';
import OtpForm from './OtpForm/OtpForm';
import SuccessModal from './SuccessModal/SuccessModal';

interface ForgotPasswordProps {
  setActiveComponent: (component: string) => void;
}

interface UserData {
  email: string;
  password: string;
  otp: string;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  setActiveComponent,
}) => {
  const [userData, setUserData] = useState<UserData>({
    email: '',
    password: '',
    otp: '',
  });

  const [step, setStep] = useState<string>('email');
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);

  const handleUserDataChange = (field: keyof UserData, value: string) => {
    setUserData((prevUserData) => ({
      ...prevUserData,
      [field]: value,
    }));
  };

  const handleOtpSent = (email: string) => {
    handleUserDataChange('email', email);
    setStep('otp');
  };

  const handleOtpVerified = (otp: string) => {
    handleUserDataChange('otp', otp);
    setStep('newPassword');
  };

  const handlePasswordChanged = (password: string) => {
    handleUserDataChange('password', password);
    setStep('done');
    setIsSuccessModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsSuccessModalOpen(false);
    setActiveComponent('login');
  };

  const renderStep = () => {
    switch (step) {
      case 'email':
        return <EmailForm onOtpSent={handleOtpSent} />;
      case 'otp':
        return (
          <OtpForm email={userData.email} onOtpVerified={handleOtpVerified} />
        );
      case 'newPassword':
        return (
          <NewPasswordForm
            setActiveComponent={setActiveComponent}
            onPasswordChanged={handlePasswordChanged}
            email={userData.email}
            otp={userData.otp}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="forgot-password">
      {!isSuccessModalOpen && (
        <BackButton onClick={() => setActiveComponent('login')} />
      )}
      {renderStep()}
      <SuccessModal isOpen={isSuccessModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default ForgotPassword;
